import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../services/auth/auth.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // Caso específico para erro 401 (sessão expirada)
        if (err.status === 401) {
          // Verificar se a requisição é para a API do WhatsApp
          const isWhatsAppApi = request.url.includes(environment.whatsappApiUrl);
          
          // Só fazer logout se NÃO for da API do WhatsApp
          if (!isWhatsAppApi) {
            this.authService.logout();
            location.reload();
          }
        }

        // Não criar um novo Error, manter o HttpErrorResponse original
        return throwError(() => err);
      }))
  }
}
